module.exports = "/4/3-auto-va-decltype/index.html.0d8f1c6d9c4f8f1eff25628a38272254.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30020.md
 ** module id = 550
 ** module chunks = 0
 **/